/* ==========================================================================
   THE COURT & CLUB — product-card and PLP behaviour.
   Dependency-free and defensive: every block bails quietly if its markup is
   absent, so one missing feature never takes the page with it.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ccPlpBooted) return;
  window.__ccPlpBooted = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Horizon scrolls .page-wrapper, not the window. Both are read, because the
     mobile layout drops the wrapper's own scroller and falls back to window. */
  var pw = $('.page-wrapper');
  function scrollY() { return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
  function onScroll(fn) {
    var t = false;
    function h() { if (t) return; t = true; requestAnimationFrame(function () { t = false; fn(); }); }
    window.addEventListener('scroll', h, { passive: true });
    if (pw) pw.addEventListener('scroll', h, { passive: true });
    h();
    return h;
  }

  function store(k, d) {
    try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; }
  }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }

  /* ---------------------------------------------------------------- bar */
  function bar() {
    var b = $('[data-ccbar]');
    if (!b) return;
    var hdr = $('.hdr');

    /* The toolbar used to stick at a hard-coded top:var(--hdr). The header
       retracts on scroll-down, so the bar stayed pinned to the height of a
       header that was no longer there — a band floating in the middle of the
       product grid, slicing the cards in half. Follow the header's ACTUAL
       visible bottom instead; it lands flush under it when the header is
       showing and rises to the top of the viewport when it has retracted. */
    function sync() {
      b.classList.toggle('is-stuck', scrollY() > 8);
      if (!hdr) return;
      var bottom = hdr.getBoundingClientRect().bottom;
      b.style.top = Math.max(0, Math.round(bottom)) + 'px';
    }

    var tick = onScroll(sync);

    /* The retract is a 420ms transform. Scroll events stop firing the moment
       the finger lifts, so without this the bar freezes wherever the last
       scroll tick left it, mid-animation. */
    if (hdr) {
      hdr.addEventListener('transitionend', sync);
      var raf = function () { sync(); };
      hdr.addEventListener('transitionrun', function () {
        var n = 0;
        (function loop() {
          if (n++ > 40) return;
          raf();
          requestAnimationFrame(loop);
        })();
      });
    }
    window.addEventListener('resize', tick, { passive: true });
  }

  /* ------------------------------------------------------- facet panels */
  function facets() {
    var wrap = $('[data-facets]');
    if (!wrap) return;

    function closeAll(except) {
      $$('[data-fac]', wrap).forEach(function (f) {
        if (f === except) return;
        f.classList.remove('is-open');
        var t = $('[data-factog]', f);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    wrap.addEventListener('click', function (e) {
      var t = e.target.closest('[data-factog]');
      if (!t) return;
      var fac = t.closest('[data-fac]');
      var open = !fac.classList.contains('is-open');
      closeAll(fac);
      fac.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-facets]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* --------------------------------------------------------- density */
  function density() {
    var grid = $('[data-ccgrid]');
    var box = $('.cc-dens');
    if (!grid || !box) return;

    function apply(n) {
      grid.setAttribute('data-cols', n);
      $$('button', box).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cols') === n ? 'true' : 'false');
      });
    }

    apply(String(store('cc:cols', 4)));

    box.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-cols]');
      if (!b) return;
      var n = b.getAttribute('data-cols');
      apply(n);
      put('cc:cols', n);
    });
  }

  /* --------------------------------------------- mobile filter drawer */
  function drawer() {
    var drw = $('[data-fdrw]'), scrim = $('[data-fscrim]'), body = $('[data-fbody]');
    var src = $('[data-facets]');
    if (!drw || !scrim || !body) return;

    /* Clone the desktop facets into accordion groups rather than authoring
       the same filter list twice — one source of truth, two presentations. */
    if (src && !body.childElementCount) {
      $$('[data-fac]', src).forEach(function (f, i) {
        var tog = $('[data-factog]', f);
        var list = $('.cc-fac__l, .cc-price', f);
        if (!tog || !list) return;
        var d = document.createElement('details');
        if (i < 2) d.open = true;
        var s = document.createElement('summary');
        s.textContent = tog.textContent.trim();
        var wrapEl = document.createElement('div');
        wrapEl.className = 'cc-fdrw__l';
        wrapEl.appendChild(list.cloneNode(true));
        d.appendChild(s);
        d.appendChild(wrapEl);
        body.appendChild(d);
      });
    }

    function open(on) {
      drw.classList.toggle('is-open', on);
      scrim.classList.toggle('is-open', on);
      scrim.hidden = !on;
      drw.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if (pw) pw.style.overflow = on ? 'hidden' : '';
    }

    $$('[data-fopen]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    $$('[data-fclose]').forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    scrim.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* ------------------------------------------------------- quick add */
  function quickadd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qadd]');
      if (!b || b.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      var label = b.textContent;
      b.classList.add('is-busy');
      b.textContent = '…';
      b.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: b.getAttribute('data-qadd'), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          b.textContent = res.ok ? '✓' : '✕';
          if (res.ok) {
            /* Reuse the header opener so the cart drawer, its per-item upsells
               and the badge all repaint through the one existing code path.
               On /cart the drawer is disabled and this same click makes the
               cart page repaint itself instead. */
            var opener = $('[data-cart-open]');
            if (opener) opener.click();
          }
          setTimeout(function () {
            b.textContent = label; b.disabled = false; b.classList.remove('is-busy');
          }, 1400);
        })
        .catch(function () {
          b.textContent = label; b.disabled = false; b.classList.remove('is-busy');
        });
    }, true);
  }

  /* ------------------------------------------------------------ saved */
  function saved() {
    var list = store('cc:saved', []);

    function paint(root) {
      $$('[data-save]', root || document).forEach(function (b) {
        b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-save')) > -1 ? 'true' : 'false');
      });
    }
    paint();

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-save]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var id = b.getAttribute('data-save');
      var i = list.indexOf(id);
      if (i > -1) list.splice(i, 1); else list.push(id);
      put('cc:saved', list);
      b.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
    }, true);

    document.addEventListener('cc:grid-appended', function (e) { paint(e.detail); });
  }

  /* -------------------------------------------------------- load more */
  function loadmore() {
    var box = $('[data-ccmore]');
    var grid = $('[data-ccgrid]');
    if (!box || !grid) return;

    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-loadmore]');
      if (!b) return;
      var url = b.getAttribute('data-loadmore');
      var label = b.textContent;
      b.textContent = 'Loading…';
      b.disabled = true;

      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-ccgrid]');
          var nextBox = doc.querySelector('[data-ccmore]');
          if (!next) throw new Error('no grid');

          var added = document.createDocumentFragment();
          Array.prototype.slice.call(next.children).forEach(function (n) { added.appendChild(n); });
          grid.appendChild(added);

          /* reveal-on-scroll is opt-in per element, so re-arm the new ones */
          $$('.rev', grid).forEach(function (el) { el.classList.add('in'); });
          document.dispatchEvent(new CustomEvent('cc:grid-appended', { detail: grid }));

          if (nextBox) { box.innerHTML = nextBox.innerHTML; } else { box.remove(); }
          try { history.replaceState({}, '', url); } catch (err) { }
        })
        .catch(function () {
          b.textContent = label;
          b.disabled = false;
          window.location.href = url;
        });
    });
  }

  function money(cents) {
    var cfg = window.CCLUXE || {};
    var f = cfg.moneyFormat || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/g, parts.join('.')).replace(/<[^>]*>/g, '');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* -------------------------------------------------- recently viewed --
     Recorded on the way OUT of a listing rather than on the product page,
     so the whole feature lives in one file instead of being threaded
     through the PDP template as well. */
  function record() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.cc-pc a[href*="/products/"], .cc-rv__c');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var h = m[1];
      var ids = store('cc:rv', []).filter(function (x) { return x !== h; });
      ids.unshift(h);
      put('cc:rv', ids.slice(0, 16));
    }, true);
  }

  function recent() {
    var sec = $('[data-ccrv]'), rail = $('[data-ccrvr]');
    if (!sec || !rail) return;
    var here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    var ids = store('cc:rv', []).filter(function (h) { return h && h !== here; }).slice(0, 12);
    if (!ids.length) return;

    Promise.all(ids.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var good = items.filter(Boolean);
      if (!good.length) return;
      rail.innerHTML = good.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + esc(p.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_400x$1$2')) + '" alt="" loading="lazy">'
          : '<span class="cc-plate"><span class="cc-plate__m">C&amp;C</span></span>';
        return '<a class="cc-rv__c" href="' + esc(p.url) + '">' +
          '<span class="cc-pc__m">' + img + '</span>' +
          '<span class="cc-pc__t" style="font-size:.875rem">' + esc(p.title) + '</span>' +
          '<span class="cc-pc__p">' + money(p.price) + '</span></a>';
      }).join('');
      sec.hidden = false;
    });
  }

  function boot() {
    bar(); facets(); density(); drawer(); quickadd(); saved(); loadmore(); record(); recent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
